import { render, staticRenderFns } from "./templateSetupSon.vue?vue&type=template&id=7eef6273&scoped=true&"
import script from "./templateSetupSon.vue?vue&type=script&lang=js&"
export * from "./templateSetupSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eef6273",
  null
  
)

export default component.exports